import { render, staticRenderFns } from "./arvioinnit.vue?vue&type=template&id=bd324892&"
import script from "./arvioinnit.vue?vue&type=script&lang=ts&"
export * from "./arvioinnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports